"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDataUrlFromFile;
function getDataUrlFromFile(file) {
  return new Promise(function (ful) {
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
      ful(e.target.result);
    };
    fileReader.readAsDataURL(file);
  });
}